import React from 'react'
import styles from './styles.module.scss'
import cn from 'classnames'

export const Input = ({className, ...props}) => {
  
  const classNames =  cn(styles.input, className)
  
  return (
    <input className={classNames} {...props}/>
  )
}

export const Select = ({className, children, ...props}) => {
  
  const classNames =  cn(styles.input, styles.select, className)
  
  return (
    <select className={classNames} {...props}>
      {children}
    </select>
  )
}